import axios from "axios";
 
const API_BASE_URL = "https://glowtechbackend.in-sciencelabs.com/api";
 
export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/contacts`, formData, {
      headers: { "Content-Type": "application/json" },
      timeout: 10000,
    });
 
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "Submission failed");
    } else if (error.request) {
      throw new Error("No response from server");
    } else {
      throw new Error("Something went wrong");
    }
  }
};
